import { Entry } from '../Entry'

export function Entry20220901() {
  return (
    <Entry title="01/09/2022 - v3.2.4">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/12766/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
